import { NavigateFunction } from "react-router";

export const goToPreviousPage = (navigate: NavigateFunction | Function, defaultPage: string) => {
  const previousPath = sessionStorage.getItem("previousPath");

  if (previousPath) {
    navigate(previousPath);
  } else {
    navigate(defaultPage);
  }
};